import {ReactNode} from "react";
import {LinkOutlined} from "@ant-design/icons";
import {StyledIntegrationVisualBox} from "../../automations.style";
import {CoachliLogoPurpleIcon} from "../../icons/coachli-logo-purple-icon";
import {GoogleMeetIcon} from "../../icons/google-meet-icon";

type IntegrationConnectionVisualProps = {
  integrationIcon?: ReactNode;
};

export function IntegrationConnectionVisual({
  integrationIcon = <GoogleMeetIcon />,
}: IntegrationConnectionVisualProps) {
  return (
    <StyledIntegrationVisualBox>
      <CoachliLogoPurpleIcon />
      <LinkOutlined className="integration-link-icon" />
      {integrationIcon}
    </StyledIntegrationVisualBox>
  );
}
